import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { SessionEditionService } from '../../_services/http/session-edition.service';
import {
  getIsEditionSessionInitialized,
  loadSessionEditionAction,
  loadSessionEditionErrorAction,
  loadSessionEditionSuccessAction,
  releaseSessionEditionAction,
  SessionEditionState,
  takeSessionEditionAction,
} from './session.store';
import {
  catchError,
  filter,
  map,
  mergeMap,
  tap,
  withLatestFrom,
} from 'rxjs/operators';
import { of } from 'rxjs';
import { DashboardService } from 'src/app/_components/dashboard/dashboard.service';

@Injectable()
export class SessionEditionEffect {
  constructor(
    private service: SessionEditionService,
    private dashboardService: DashboardService,
    private actions$: Actions,
    private store: Store<SessionEditionState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSessionEditionAction),
      withLatestFrom(this.store.select(getIsEditionSessionInitialized)),
      filter(([action, isInitialized]) => !isInitialized),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadSessionEditionSuccessAction({ payload })),
          catchError(() => of(loadSessionEditionErrorAction()))
        )
      )
    )
  );

  take$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(takeSessionEditionAction),
        tap((action) => this.service.take().subscribe())
      ),
    { dispatch: false }
  );

  release$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(releaseSessionEditionAction),
        tap((action) => {
          this.service.release().subscribe();
          this.dashboardService.closeWidget('MapEditComponent');
        })
      ),
    { dispatch: false }
  );
}
